import React, { useState, useEffect, Fragment } from 'react'
import { Grid, Carousel, Card, InputLabel } from '@scuf/common'
import Bar from '../../components/charts/Bar/Bar'
import Column from '../../components/charts/Column/Column'
import KPIStat from '../../components/common/KPIStat/KPIStat'
import DatTab from '../../components/common/DatTab/DatTab'
import BarStacked from '../../components/charts/BarStacked/BarStacked'
import { isMobile } from "react-device-detect";
import { DataTable } from '@scuf/datatable';
import { useDispatch } from 'react-redux'
import baseServices from '../../services/base.services';

const width = window.innerWidth;
//let isMobile = (width <= 68);


const DatTabAlarms = ({titleCard, division}) => {
    const [alertas, setState] = useState([])

    useEffect(() => {
        const getData = async () => {
            try {
             
                var response = await baseServices.getAlarms({type: 3, siteID: 0,  date: null }, 'getAlarmsState');
                if (response.data && response.data.length > 0) {
                    setState(response.data)
                    setTimeout(() => {
                        getData()
                    }, 150000);

                }      

            } catch (err) {
                console.log(err);
            }
        }
        getData()
    }, [])


    return (
        <>                 
            <Fragment>
                <InputLabel label={titleCard} style={{ Color: 'red' }} />
                <DataTable data={alertas.length > 0 ? alertas.filter(x=> x.SiteName == division) : []} scrollable={true} scrollHeight="300%"
                    reorderableColumns={true} resizableColumns={true}>

                <DataTable.Column field="WhatsappMessage" header="Alerta" sortable={true} />
                <DataTable.Column field="Time" header="Tiempo (m)" sortable={true} />

                    {/* <DataTable.Column field="plane" header="plane" sortable={true} />
                <DataTable.Column field="pilot" header="pilot" sortable={true} />
                <DataTable.Column field="status" header="status" sortable={true} />
                <DataTable.Column field="flights" header="flights" sortable={true} /> */}

                </DataTable>
            </Fragment>
            
        </>
    )
}
export default DatTabAlarms;